import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import { Row, Col } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { CSVLink } from "react-csv";
import moment from "moment";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import delete_icon from "../../assets/images/icon/delete.svg";
import edit_icon from "../../assets/images/icon/edit.svg";
import plus_icon from "../../assets/images/icon/plus.svg";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";

import {
  GetDepartmentList,
  DeleteRecords,
} from "../../services/DepartmentService";
import { toast } from "react-toastify";
import {
  checkPermissionStatus,
  getCompanyTimezoneDateTime,
} from "helpers/utils";
import { decryptDataFromArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";
import SearchBar from "components/Common/Searchbar";

const DepartmentList = () => {
  const { t } = useTranslation();
  const [departmentList, setDepartmentList] = useState([]);
  const [query, setQuery] = useState("");
  const [csvData, setCSVData] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const companyId = localStorage.getItem("subdomainId");

  const fetchDepartmentList = () => {
    GetDepartmentList(query)
      .then(res => {
        if (res?.status === 200) {
          let responseData = res?.data;
          responseData = decryptDataFromArray(responseData);
          console.log(responseData,"responseData")
          setDepartmentList(responseData?.data);
        }
      })
      .catch(err => {
        console.error("Error fetching department list:", err);
      });
  };

  useEffect(() => {
    fetchDepartmentList();

    document.title = "NeuroTal - Department List";
  }, []);

  

  const handleDeleteRecords = id => {
    DeleteRecords(id)
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (res?.status === 200) {
          let messages = toast.success(responseData?.message);

          fetchDepartmentList();
        } else {
          let messages = toast.error(responseData?.message);
        }
      })
      .catch(error => {
        console.error("Error deleting record:", error);
      });
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Location_Manager.Showing rows`, { from, to, size })}
    </span>
  );

  //Handle CSV

  const handleCSVDownload = async e => {
    e.preventDefault();
    let data = departmentList;
    //console.log('departmentList',departmentList)
    setCSVData(data);
    setTimeout(() => {
      let element = document.getElementById("downloadCSV");
      element.click();
    }, 1000);
  };

  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "Next page",
    prePageTitle: "Pre page",
    firstPageTitle:"First page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  let columns = [
    {
      text: t(`Department.id`),
      dataField: "_id",
      sort: true,
      hidden: true,
    },
    {
      dataField: "company.company_name",
      text: t(`Department.Company Name`),
      hidden: companyId, // Hide the column if companyId exist
    },
    {
      dataField: "name",
      text: t(`Department.Department Name`),
    },

    {
      dataField: "description",
      text: t(`Department.Description`),
    },
    {
      dataField: "sequence",
      text: t(`Department.Sequence`),
    },
    {
      dataField: "createdAt",
      text: t(`Department.Created At`),
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format("DD MMM YYYY");
      },
    },
    {
      dataField: "status",
      text: t(`Department.Status`),
      formatter: (cellContent, row) => (
        <>
          {row?.status == "1"
            ? t(`Location_Manager.Active`)
            : t(`Location_Manager.Inactive`)}
        </>
      ),
    },
  ];

  

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  const rowClasses = (row, rowIndex) => {
    let baseClass = rowIndex % 2 === 0 ? "even-row" : "odd-row";

    if (row.id !== undefined && row.id < 10) {
      return `${baseClass} ijuuhsdhsyhsdyhs`;
    }

    return baseClass;
  };

  const tbodyRef = useRef(null);

  useEffect(() => {
    if (tbodyRef.current) {
      if (departmentList.length < 10) {
        tbodyRef.current.style.height = "700px";
      } else {
        tbodyRef.current.style.height = "auto";
      }
    }
  }, [departmentList.length]);

  

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  if (!checkPermissionStatus("department-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Department.Access Denied`)}</h4>
      </div>
    );
  }
  if (checkPermissionStatus("department-list", "edit")) {
    columns.push({
      dataField: "",
      text: t(`Department.Actions`),
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            <div className="action-one small-img">
              <Link
                className="text-success blue-icon blue-color4"
                to={`/edit-department/${row.id}`}
                title={t(`Department.Edit Department Type`)}
              >
                <img src={edit_icon} alt="edit icon" aria-hidden="true" />
                <span>{t(`Department.Edit Department`)}</span>
              </Link>
            </div>

            <div className="action-one small-img">
              <div
                className="text-success blue-icon blue-color3"
                onClick={() => handleDeleteRecords(row.id)}
                style={{ cursor: "pointer" }}
                title={t(`Department.Delete Department Type`)}
              >
                <img src={delete_icon} alt="delete_icon" />
                <span>{t(`Department.Delete`)}</span>
              </div>
            </div>
          </div>
        );
      },
    });
  }
  return (
    <>
      <div className="pending-list-page feedbacks departmentpage">
        <div className="tab-content" id="pills-tabContent">
          <div className="joblist-container create-vacancy main-pages-s">
            <Row className="mb-2 align-items-center">
              <Col lg="6" md="6" className="Joblist-column">
                <Link to="/dashboard">
                  <h5 className="text-uppercase heading-one">
                    <img src={arrow_btn} alt="arrow_btn" />
                    {t(`Department.Department List`)}
                  </h5>
                </Link>
              </Col>
            </Row>
          </div>

          {/* <div className="outerTab-box-wrapper below-vacancy amsterresign  joblist-pages-spaces"> */}
          <div className="outerTab-box-wrapper applicationcard-table">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              // aria-labelledby="pills-home-tab"
            >
              <div className="tabel-application table-responsive pb-3">
                <div className="table-data-search pbresop">
                  <div className="total-record">
                    <h5>
                      {t(`Department.Total Records`)}:{" "}
                      <span>{departmentList ? departmentList.length : 0}</span>
                    </h5>
                  </div>
                  <div className="total-serachbar">
                    <SearchBar
                      onSearch={fetchDepartmentList}
                      title={t(`Department.Search by name, description`)}
                      placeholder={t(`Department.Search by name, description`)}
                      query={query}
                      setQuery={setQuery}
                    />

                    {checkPermissionStatus(
                      "department-list",
                      "downloadcsv"
                    ) && (
                      <div className="take-text">
                        <CSVLink
                          data={csvData}
                          headers={[
                            {
                              key: "id",
                              label: t(`Department.Serial No`),
                            },
                            {
                              key: "name",
                              label: t(`Department.Department Name`),
                            },
                            {
                              key: "description",
                              label: t(`Department.Description`),
                            },
                            {
                              key: "sequence",
                              label: t(`Department.Sequence`),
                            },
                            {
                              key: "status",
                              label: t(`Department.Status`),
                            },
                            {
                              key: "createdAt",
                              label: t(`Department.Created At`),
                            },
                            {
                              key: !companyId ? "Company.company_name" : "", // Conditionally include "Company Name" if companyId does't exists
                              label: !companyId ? "Company Name" : "",
                            },
                          ]}
                          filename={`DepartmentList.csv`}
                          id="downloadCSV"
                        >
                          <Button
                            color="info"
                            onClick={e => handleCSVDownload(e)}
                            outline
                          >
                            <img src={dowanload_csv} alt="Download" />{" "}
                            {t(`Department.Download CSV`)}
                          </Button>
                        </CSVLink>
                      </div>
                    )}

                    {checkPermissionStatus("department-list", "create") && (
                      <div className="take-text filter">
                        <Link
                          to="/create-department"
                          className="btn btn-primary d-flex align-items-center gap-2"
                        >
                          <img
                            src={plus_icon}
                            alt="Download"
                            className="plus-icon"
                          />{" "}
                          {t(`Department.Create`)}
                        </Link>
                      </div>
                    )}

                    <div className="tale-text right-panel mobile-arrow">
                      <button
                        className="button left"
                        onClick={() => handleScroll("left")}
                        data-tooltip="Scroll Left"
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                      <button
                        className="button right"
                        onClick={() => handleScroll("right")}
                        data-tooltip="Scroll Right"
                      >
                        <img src={right_arrow} alt="right arrow 1" />
                      </button>
                    </div>
                  </div>
                </div>
                {successMessage && (
                  <div class="alert alert-success" role="alert">
                    {successMessage}
                  </div>
                )}
                {errorMessage && (
                  <div class="alert alert-danger" role="alert">
                    {errorMessage}
                  </div>
                )}
                <div className="timeto-hire-card userlist pendiglist-cardss">
                  <div className="table-custome-class range-custome">
                    <>
                      <div className="scroll-container">
                        <div className="table-pending-list">
                          <div className="table-wrapper" ref={tableWrapperRef}>
                            <BootstrapTable
                              keyField="id"
                              data={departmentList}
                              columns={columns}
                              pagination={paginationFactory(options)}
                              rowClasses={rowClasses}
                              hover
                              responsive
                              wrapperClasses="table-wrapper"
                              bodyRef={tbodyRef}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DepartmentList;
